export const parsePlayer = (player) =>
  player || {
    id: null,
    firstName: null,
    lastName: null,
    number: null,
    position: null,
    teamId: null,
  };

export const getPlayersById = (resp) => {
  const allPlayers = [];

  resp.forEach(({ players }) => allPlayers.push(...players));

  return allPlayers.reduce((acc, curr) => {
    return {
      ...acc,
      [curr.id]: {
        ...curr,
        firstName: parsePlayer(curr).firstName,
        id: parsePlayer(curr).id,
        lastName: parsePlayer(curr).lastName,
        fullName: `${parsePlayer(curr).firstName} ${parsePlayer(curr).lastName}`,
        number: parsePlayer(curr).number,
        position: parsePlayer(curr).position,
        teamId: parsePlayer(curr).teamId,
      },
    };
  }, {});
};
